/* eslint-disable react/react-in-jsx-scope */
import { File, Folder, Tree } from "@/components/extension/tree-view-api";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import { TreeProgram, TreeProject, TreeRoot } from "@/types";
import { FolderIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
const TreeView = () => {
  const { idPp, projectId, firstname } = useParams();
  const page = window.location.pathname;
  const { t } = useTranslation("dashboard", {
    keyPrefix: "tree",
  });
  const {
    data: treeFinancer,
    loading: loadingTreeFinancer,
    error: errorTreeFinancer,
  } = useFetchDataV2<TreeRoot[]>(
    `${import.meta.env.VITE_API_ENDPOINT}/tree/financer`,
    `tree-financer`,
    1000 * 60 * 60
  );
  const elements = [
    {
      id: "1",
      isSelectable: true,
      name: "Porteur de projet",
      children: treeFinancer
        ?.map((item: TreeRoot) => {
          return {
            id: `pp-${item.id}`,
            isSelectable: true,
            name: "PP - " + item.name,
            children: item?.programs
              ?.map((program: TreeProgram) => {
                return {
                  id: `program-${program.id}`,
                  isSelectable: true,
                  name: program.name,
                  children: program?.projects
                    ?.map((project: TreeProject) => {
                      return {
                        id: `project-${project.id}`,
                        isSelectable: true,
                        name: project.name,
                      };
                    })
                    .filter(Boolean),
                };
              })
              .filter(Boolean),
          };
        })
        .filter(Boolean),
    },
  ];
  let idPorteurProject = null;
  if (
    idPp &&
    treeFinancer &&
    treeFinancer?.length > 0 &&
    page.search("mes-documents") == 0
  ) {
    idPorteurProject = treeFinancer.find(
      (item) => item.id.toString() === idPp
    )?.id;
  }
  const initialSelectedId = idPorteurProject
    ? `pp-${idPorteurProject}`
    : projectId
    ? `project-${projectId}`
    : "0";

  if (loadingTreeFinancer) return <LoadingSpinner />;
  if (errorTreeFinancer)
    return (
      <div>
        {t("Une erreur est survenue:")} {errorTreeFinancer}
      </div>
    );

  return (
    <Tree
      initialSelectedId={initialSelectedId}
      elements={elements}
      className="mb-4"
      id="Mes porteurs de projet"
    >
      <Folder element={t("Porteur de projet")} value="1" visibleChevron={true}>
        <div className="flex flex-col gap-1">
          {treeFinancer?.map((pp: TreeRoot) => (
            <Folder
              key={`pp-${pp.id}`}
              element={`${pp.name}`}
              value={`pp-${pp.id}`}
              visibleChevron={true}
              className="py-1"
              idElement={pp.id}
            >
              {pp.programs.map((program: TreeProgram) => (
                <Folder
                  key={`program-${program.id}`}
                  element={program.name}
                  value={`program-${program.id}`}
                  visibleChevron={true}
                  className="py-1"
                  idElement={program.id}
                >
                  {program.projects.map((project: TreeProject) => (
                    // <Folder
                    //   key={`project-${project.id}`}
                    //   element={project.name}
                    //   value={`project-${project.id}`}
                    //   visibleChevron={false}
                    //   className="w-full items-start text-left"
                    //   idElement={project.id}
                    // />
                    <File
                      key={`file-${project.id}`}
                      value={`file-${project.id}`}
                      className="py-1 ml-3"
                      fileIcon={
                        <FolderIcon
                          size={18}
                          className="text-muted-foreground"
                        />
                      }
                      title={project.name}
                      isSelectable={true}
                      isSelect={
                        projectId
                          ? projectId === project.id.toString()
                            ? true
                            : false
                          : false
                      }
                      url={`/${firstname}/project/${project.id}`}
                    >
                      <span className="w-full truncate flex-1 text-muted-foreground">
                        {project.name}
                      </span>
                    </File>
                  ))}
                </Folder>
              ))}
            </Folder>
          ))}
        </div>
      </Folder>
    </Tree>
  );
};

export default TreeView;
